var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_400",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28868",
    "data-name": "Group 28868",
    transform: "translate(-4833 6237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4833, -6237)",
    filter: "url(#Ellipse_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_400-2",
    "data-name": "Ellipse 400",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_4_",
    "data-name": "svgexport-17 (4)",
    transform: "translate(4852 -6212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49765",
    "data-name": "Path 49765",
    d: "M29.217,135.076a3.285,3.285,0,0,1-5.608,2.323l-2.323-2.323h0l-2.734,1.444L17.4,138.966l2.345,2.345a8.817,8.817,0,0,0,15.052-6.235l-2.887-1.227ZM0,135.076a8.817,8.817,0,0,1,15.052-6.235l2.345,2.345-.866,2.807-3.023,1.083h0l-2.322-2.323a3.285,3.285,0,0,0-5.608,2.323l-2.833.722Z",
    transform: "translate(0 -126.259)",
    fill: "#0089de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49766",
    "data-name": "Path 49766",
    d: "M214.477,135.076a3.285,3.285,0,0,0-5.608-2.323l-2.323,2.323h0l-4.9,1.444-2.879-1.444,3.889-3.89L205,128.841a8.817,8.817,0,0,1,15.052,6.235Z",
    transform: "translate(-185.26 -126.26)",
    fill: "#2ad7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49767",
    "data-name": "Path 49767",
    d: "M13.507,256l-2.323,2.323A3.285,3.285,0,0,1,5.576,256H0a8.818,8.818,0,0,0,15.052,6.235l2.345-2.345L21.285,256Z",
    transform: "translate(0 -247.183)",
    fill: "#29b0ea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.b1c852f68fbc62be9e8075bf777c6721.svg";
export { ForwardRef as ReactComponent };